import { render } from "./SuperAdminPage.vue?vue&type=template&id=6454e23a&scoped=true"
import script from "./SuperAdminPage.vue?vue&type=script&lang=js"
export * from "./SuperAdminPage.vue?vue&type=script&lang=js"

import "./SuperAdminPage.vue?vue&type=style&index=0&id=6454e23a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6454e23a"]])

export default __exports__